import { useEffect } from 'react';
import type { Filters, Results } from '@/interfaces';
import { trackResultPage } from '@/lib/utils/tracking';

export const useTrackResultPage = (results: Results, filters: Filters) => {
    useEffect(() => {
        trackResultPage(results, filters);
    }, [results.offers]); // Only trigger new tracking when the list of offers changes
};
